import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  inputStyle,
  inputContainerStyle,
  loadingContainer,
  submitButtonStyle,
  errorMsgStyle,
  playlistLinksContainer,
  playlistLinkStyle,
  dividerContainer,
  dividerLine,
  dividerText,
  title,
} from "./summarization_request_styles";
import { getOrFetchContent } from "@sharpana/auth/api_client/summarization_api";
import { GradientLoadingText } from "@sharpana/ui/GradientLoadingText";
import { emptyStateContainer } from "./my_playlists_styles";

// Removed pulsatingText, loadingDotsContainer, and AnimatedDots - now imported from GradientLoadingText

export const SummarizationURLRequest = () => {
  const [inputValue, setInputValue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  async function fetchContentAndRequestSummary() {
    setLoading(true);
    setErrorMsg("");
    const result = await getOrFetchContent(inputValue);
    if (result.error) {
      setErrorMsg(result.error);
      setLoading(false);
    } else {
      navigate(`/summary/${result.content_resource_id}`);
      setLoading(false);
    }
  }

  return (
    <>
      {!!errorMsg && <div css={errorMsgStyle}>{errorMsg}</div>}
      {loading ? (
        <div css={loadingContainer}>
          <GradientLoadingText text="Fetching transcript" />
        </div>
      ) : (
        <>
          <br />

          {/* <div css={emptyStateContainer}> */}
          <div>
            <div css={title}>Create new summary</div>
            <div css={inputContainerStyle}>
              <input
                type="text"
                placeholder="YouTube video link"
                value={inputValue}
                onChange={handleInputChange}
                css={inputStyle}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchContentAndRequestSummary();
                  }
                }}
              />
              <div
                onClick={() => {
                  fetchContentAndRequestSummary();
                }}
                disabled={loading}
                css={submitButtonStyle}
              >
                Go
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
